import type { MerchantBusiness, MerchantDomain } from "features/merchants/types";
import type { MerchantDomainsRepositoryState } from "./types";
import { ApiState } from "infrastructure/api";

export const stateFactory: () => MerchantDomainsRepositoryState = () => ({
    apiState: ApiState.Idle,
    businesses: Array.of<MerchantBusiness>(),
    domains: new Map<MerchantDomain['merchantBusinessId'], Array<MerchantDomain>>()
});
